import createStore from "zustand";
import { paths } from "lib/__generatedApiSpec";
import { OpReturnType } from "openapi-typescript-fetch";
import { SetStateAction } from "react";

//@ts-ignore
type NotifData = OpReturnType<paths["/notification"]["get"]>["data"];

export type HomeStore = {
  // States
  userNotifications: NotifData | null;
  newLessonComplete: Boolean;
  renderingStep: number;
  isShowSearchModal: boolean;

  // Actions
  setNotification: (notif: NotifData) => void;
  setNewLessonComplete: (lessonCompleted: Boolean) => void;
  setRenderingStep: (step: SetStateAction<number>) => void;
  setIsShowSearchModal: (isShow: SetStateAction<boolean>) => void;
};

export const useHomeStore = createStore<HomeStore>((set) => ({
  // States
  userNotifications: null,
  newLessonComplete: false,
  renderingStep: 1,
  isShowSearchModal: true,

  // Actions
  setNotification(userNotifications) {
    set({
      userNotifications,
    });
  },
  setNewLessonComplete(newLessonComplete) {
    set({
      newLessonComplete,
    });
  },
  setRenderingStep: (step) =>
    set((state) => ({
      renderingStep:
        typeof step === "function" ? step(state.renderingStep) : step,
    })),
  setIsShowSearchModal: (isShow) =>
    set((state) => ({
      isShowSearchModal:
        typeof isShow === "function" ? isShow(state.isShowSearchModal) : isShow,
    })),
}));
